// extracted by mini-css-extract-plugin
export default {"header":"oR-z","isActive":"pR-z"};